<mat-form-field *ngIf="dateFormat">
  <input
    type="hidden"
    [matDatepicker]="picker"
    [(ngModel)]="valueIn"
    (ngModelChange)="onChangeMonth($event, picker)"
    [min]="min"
    [max]="max"
  />
  <div class="form-control">
    <input
      matInput
      showMaskTyped="true"
      [mask]="mask.mask"
      [ngModel]="valueIn | date: dateFormat"
      (blur)="onBlur()"
      (change)="todate($event.target.value)"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

    <mat-datepicker #picker startView="year" (monthSelected)="onChangeMonth($event, picker)"></mat-datepicker>
  </div>
</mat-form-field>
